<template>
	<div class="pregnant">
		<Loading msg="loading" v-if="!isload" />
		<div class="pregnant_inner" v-else>
          	<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <img src="../assets/images/pregnant_head_pic.png" class="pregnant_head_pic" alt="">
                <div class="pregnant_inner_info">
                <h1 class="pregnant_title">你的孕期糖尿病风险高吗?</h1>
                <!-- <div class="ask_yourself_title">首先我们来做一道选择题，你觉得你是？</div> -->
                <p class="ask_yourself_info">很多怀孕了的妈妈都会有这样的顾虑，怀孕前明明自己也是个身体健康的乖宝宝，为什么怀孕之后这病那病就来了，尤其自己怀孕后还得了糖尿病。而很多妈妈却不知道妊娠期糖尿病是孕期比较容易患上的一种病。</p>
                <p class="ask_yourself_info">随着宝宝的生长发育，对于母体的物质需求日渐增多，导致母体发生一系列的生理变化，其中以糖代谢的变化较为突出。妊娠期糖尿病发生的主要原因就是糖代谢的异常。</p>
                <p class="ask_yourself_info">但是除此之外，还有一个影响你孕期是否容易得糖尿病的原因——基因！</p>
                <p class="ask_yourself_sub">如果我们总是忽略了基因对于自己的影响，它自己都看不下去了，所以必须出来为自己的存在感尽一份力。</p>

                <div class="pregnant_gene_result">
                    <div class="gene_result_title">您的基因结果显示</div>
                    <div class="gene_result_sub_title"><span>基因:GCKR</span><span>位点:rs1260326</span></div>
                    <ul class="gene_result_info">
                        <li class="info_item info_title"><span class="item_name">基因型</span><span class="item_result">检测结果</span></li>
                        <li class="info_item" :class="pregnant_result == 'TT' ? 'now' : ''"><span class="item_name">TT</span><span class="item_result">孕期患有糖尿病风险较低</span></li>
                        <li class="info_item" :class="((pregnant_result == 'TC') || (pregnant_result == 'CT')) ? 'now' : ''"><span class="item_name">TC</span><span class="item_result">孕期患有糖尿病风险中等</span></li>
                        <li class="info_item" :class="pregnant_result == 'CC' ? 'now' : ''"><span class="item_name">CC</span><span class="item_result">孕期患有糖尿病风险较高</span></li>
                    </ul>
                    <p class="gene_result_info_tip">如果您为男士，就当没这回事儿~</p>

                </div>

                <div class="pregnant_2nd_title">基因详情:</div>
                <p class="pregnant_2nd_text">一个名为GCKR的基因与空腹血糖水平，胰岛素水平有关.。对于孕期女性，GCKR基因则与FPG（Fasting plasma glucose，空腹血糖水平）、FCP（Fasting C-peptide，空腹C肽水平）有关。 </p>
                <p class="pregnant_2nd_text">它的全名是glucokinase regulator（葡糖激酶调节器）， 该基因编码的蛋白能够抑制性地调控肝脏和胰岛细胞中的葡糖激酶。 </p>
                <p class="pregnant_2nd_text">GCKR基因的rs1260326位点与孕期女性的FPG和FCP有着显著的相关性。如果在该基因位点上你的基因型是TT，那么你在孕期血糖偏高的风险性就较低，换言之你可能不容易在怀孕期间患上糖尿病。 </p>
                <p class="pregnant_2nd_text">但如果你携带了C等位基因，那么你在孕期患有糖尿病的风险就会有所上升，并且CC型比TC型的风险更高。 </p>
                <img src="../assets/images/pregnant_middle_pic.png" class="pregnant_down_pic" alt="">
                <!-- <div class="pregnant_2nd_title">COMT基因影响你的选择</div> -->
                <p class="pregnant_2nd_text">维持正常的孕期血糖水平是有助于后代的健康成长的。如果母亲已经患有糖尿病或者在孕期患上了妊娠期糖尿病，那么不管是还在腹中的胎儿还是已经降生的新生儿都是有一定的影响的。 </p>
                <p class="pregnant_2nd_text">例如，因为孕期孕妇血糖过高，胎儿长期处于母体高血糖所致的高胰岛素血症环境中，会导致躯干过度发育。同时，胎儿畸形的几率也会高于非糖尿病孕妇.而新生儿患有呼吸窘迫综合征和低血糖的几率也会更高。 </p>
                <p class="pregnant_2nd_text">因此，若先天基因导致的结果是你在孕期容易有高血糖风险的话，在怀孕时就应当注意增加运动，少食多餐，以及严重控制餐后的血糖，这样对胎儿和妈妈都是安全的。 </p>
                <div class="pregnant_share_tip">长按图片分享</div>
                <v-touch v-on:pressup="$parent.trackLog((actParams = { query: $route.query, pageid: 471 }),{is_access:true,reportEvent_page_id:'471',reportEvent_page_name:'你的孕期糖尿病风险高吗-分享图',reportEvent_report_type:'199基因',reportEvent_first_module:'基因有讲究',reportEvent_second_module:'分享'});">
                <img :src="pregnant_img" :key="pregnant_img" class="pregnant_share_pic" alt="">
                </v-touch>
   
            </div>
        </div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";

export default {
  name: "pregnant",
  data() {
    return {
      isload: false,
      pregnant_result:"",
      pregnant_img:""
    
    };
  },

  created() {
    console.log("pregnant created", this);
    this.initPregnant();
  },
  mounted() {
    //判断内容是否少于一屏
    let window_h = window.innerHeight;
    let body_h = document.querySelector("body").offsetHeight;
    if (body_h <= window_h) {
      document.querySelector("body").style.height = window_h + "px";
      document.querySelector("body").style.backgroundColor = "#f9f8f8";
    }
  },
  methods: {
    //初始化 桃花指数
    initPregnant: function() {
      let that = this;
      var local_pregnant = JSON.parse(localStorage.getItem("local_pregnant"));
      if (local_pregnant) {
        after_pregnant(local_pregnant);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/Gene_Share_Img/get199Type1005"
          )
          .then(json => {
            console.log("pregnant", json);
            // localStorage.setItem("local_pregnant",JSON.stringify(json));
            after_pregnant(json);
          })
          .catch(err => {
            // Failed.
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function after_pregnant(pregnant_data) {
        console.log("pregnantdata", pregnant_data);
        if (pregnant_data.code == 0) {
            that.pregnant_result = pregnant_data.data.genotype;
            that.pregnant_img = pregnant_data.data.img;
          that.isload = true;
        }
      }
    },

    markpopupBtn: function() {
      this.markpopup.show = false;
      let _status = this.total_data.data.targetquestions.tag;
      if (_status == 1) {
        this.$router.push("/article/explainoth");
      } else if (_status == 2) {
        this.$router.push("/article/explain");
      }
    },
    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.back_btn {
  position: fixed;
  top: 30/50rem;
  left: 0;
  z-index: 99999;
  width: 118/50rem;
  height: 54/50rem;
}
.report_page {
  box-sizing: border-box;
  position: relative;
}
.report_page {
  background: @bg_c_m;
}
.pregnant_head_pic{
    width:100%;
}
.pregnant_inner{
    padding:0 0 202/50rem;
    .pregnant_inner_info{
        padding:0 30/50rem;
    }
    .pregnant_title{
    position:relative;
    padding:46/50rem 0 72/50rem;
    margin-bottom:50/50rem;
    font-size:44/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-0;
    &::after{
        content:'';
        display:block;
        position:absolute;
        left:0;
        bottom:0;
        width:136/50rem;
        height:3/50rem;
        background:@font-c-detail;
    }
    }
    .ask_yourself_title{
        padding-bottom:16/50rem;
        font-size:28/50rem;
        line-height:1em;
        color:@font-c-6;
    }
    .ask_yourself_info{
        padding-bottom:20/50rem;
        font-size:28/50rem;
        line-height:36/50rem;
        color:@font-c-3;
      
    }
    .ask_yourself_sub{
        padding-bottom:54/50rem;
        font-size:28/50rem;
        line-height:36/50rem;
        color:@font-c-3;
    }
}
.pregnant_gene_result{
    padding-bottom:30/50rem;
    .gene_result_title{
        font-size:34/50rem;
        line-height:1em;
        color:@font-c-detail;
        font-weight:bold;
        text-align:center;
    }
    .gene_result_sub_title{
        padding:26/50rem 0 19/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        span{
            .flex_0;
            .align-items_center;
            font-size:28/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-right:39/50rem;
        }
    }
}
.gene_result_info{
    background:@bg_c_l;
    box-sizing:border-box;
    padding:46/50rem 30/50rem 25/50rem;
    .shadow();
    .border-radius(14/50rem);
    .info_item{
        &.now::after{
            .flex_0;
            .align-items_center;
            content:"";
            display:block;
            width:35/50rem;
            height:20/50rem;
            background:url('../assets/images/check_icon_light.png') no-repeat 0 0;
            background-size:contain;
        }
        &.now{
            color:@font-c-detail;
        }
        padding-bottom:30/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        font-size:30/50rem;
        line-height:1em;
        color:@font-c-3;
        .item_name{
            .flex_0;
            .align-items_center;
            box-sizing:border-box;
            width:36%;
            padding-left:70/50rem;
        }
        .item_result{
            .flex_0;
            .align-items_center;
            box-sizing:border-box;
            // width:47%;
            padding-right:20/50rem;
        }
    }
    .info_title{
        font-weight:bold;
        border-bottom:2/50rem solid @font-c-detail;
        padding-bottom:13/50rem!important;
        margin-bottom:30/50rem;
    }
}
.gene_result_info_tip{
    padding-top:20/50rem;
    font-size:28/50rem;
    line-height:1em;
    color:@font-c-3;
    text-align:center;
}
.pregnant_2nd_title{
    position:relative;
    padding-left:22/50rem;
    margin-top:70/50rem;
    margin-bottom:20/50rem;
    font-size:34/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-3;
    &::before{
        content:"";
        display:block;
        position:absolute;
        left:0;
        top:50%;
        -webkit-transform:translateY(-50%);
        transform:translateY(-50%);
        width:6/50rem;
        height:22/50rem;
        background:@font-c-detail;
    }
}
.pregnant_2nd_text{
    padding:0 0 40/50rem;
    font-size:28/50rem;
    line-height:38/50rem;
    color:@font-c-3;
}
.pregnant_down_pic{
    display:block;
    margin-bottom:40/50rem;
    width:100%;
}
.pregnant_share_tip{
    padding:40/50rem 0 24/50rem;
    text-align:right;
    font-size:28/50rem;
    line-height:1em;
    color:@font-c-3;
}
.pregnant_share_pic{
    width:100%;
    .shadow();
    .border-radius(14/50rem);
}

</style>
